/* eslint-disable */
import React from 'react';
import { Box, Tabs, Tab, Button, useTheme } from '@mui/material';
import { ExpandMore, ExpandLess } from '@mui/icons-material';

interface SectionNavigationProps {
  currentSection: string | null;
  onSectionChange: (section: string | null) => void;
  sections: Array<{ id: string; label: string; count: number }>;
  allExpanded: boolean;
  onToggleExpand: () => void;
}

export const SectionNavigation: React.FC<SectionNavigationProps> = ({
  currentSection,
  onSectionChange,
  sections,
  allExpanded,
  onToggleExpand,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: 'sticky',
        top: { xs: 128, md: 128 }, // Below sticky header
        backgroundColor: theme.palette.background.paper,
        borderBottom: `1px solid ${theme.palette.divider}`,
        zIndex: theme.zIndex.appBar - 2,
        mb: 4,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 0.5 }}>
        <Tabs
          value={currentSection || false}
          onChange={(_e, value) => onSectionChange(value)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            minHeight: 48,
            '& .MuiTabs-indicator': {
              backgroundColor: theme.palette.mode === 'dark' ? '#90caf9' : '#1976d2',
            },
          }}
        >
          {sections.map((section) => (
            <Tab
              key={section.id}
              label={`${section.label} (${section.count})`}
              value={section.id}
              sx={{ minHeight: 48 }}
            />
          ))}
        </Tabs>
        <Button
          size="small"
          startIcon={allExpanded ? <ExpandLess /> : <ExpandMore />}
          onClick={onToggleExpand}
          sx={{ ml: 2 }}
        >
          {allExpanded ? 'Collapse All' : 'Expand All'}
        </Button>
      </Box>
    </Box>
  );
};
